import Service from './Service'
import {http} from './config'

export default class AdministrativoService extends Service{

    constructor(){
        super('administrativo');
    }

    Login(model){
        return http.post(`${this._nomeControle}/Login`, model);
    }
    
    ListarEmpresas(skip, take, cpfCnpj, nome, plano, situacao, crm, origem){
        return http.get(`${this._nomeControle}/ListarEmpresas`, {
            params:{
                skip,
                take,
                cpfCnpj,
                nome,
                plano,
                situacao,
                crm,
                origem
            }
        });
    }

    RelatorioEmpresa(){
        return http.get(`${this._nomeControle}/RelatorioEmpresa`);
    }
    
    RelatorioUltimoLogin(){
        return http.get(`${this._nomeControle}/RelatorioUltimoLogin`);
    }
}